export const CMEFundsIcon = ({ size = 80 }) => (
  <img
    src="/images/Funds.png"
    alt="CME Funds"
    width={size}
    height={size}
    style={{ objectFit: 'contain' }}
  />
);

export const CMECreditsIcon = ({ size = 80 }) => (
  <img
    src="/images/Credit.png"
    alt="CME Credits"
    width={size}
    height={size}
    style={{ objectFit: 'contain' }}
  />
);

export const VaultIcon = ({ size = 80 }) => (
  <img
    src="/images/Vault.png"
    alt="Vault"
    width={size}
    height={size}
    style={{ objectFit: 'contain' }}
  />
);

export const MarketplaceIcon = ({ size = 80 }) => (
  <img
    src="/images/Marketplace.png"
    alt="Marketplace"
    width={size}
    height={size}
    style={{ objectFit: 'contain' }}
  />
);

export const ClinicalUpdatesIcon = ({ size = 80 }) => (
  <img
    src="/images/Clinical_Updates.png"
    alt="Clinical Updates"
    width={size}
    height={size}
    style={{ objectFit: 'contain' }}
  />
);
